// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BuildTwoToneSvg from "@fishx/icons-svg/es/asn/BuildTwoTone";
import FishxIcon from '../components/FishxIcon';

var BuildTwoTone = function BuildTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BuildTwoToneSvg
  }));
};

BuildTwoTone.displayName = 'BuildTwoTone';
export default React.forwardRef(BuildTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BuildTwoTone.js
// module id = 2132
// module chunks = 0